var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18903 2.61595V6.05464H15.1595V2.61595H16.6598C17.0695 2.61595 17.4021 2.9985 17.4021 3.4696V17.2364C17.402 17.4627 17.3237 17.6797 17.1845 17.8398C17.0453 17.9998 16.8567 18.0898 16.6598 18.09H4.68872C4.49185 18.09 4.30304 18.0001 4.16383 17.84C4.02462 17.6799 3.94641 17.4628 3.94641 17.2364V3.4696C3.94641 2.9985 4.27907 2.61595 4.68872 2.61595H6.18903ZM8.43166 13.7917H6.93658V15.511H8.43166V13.7917ZM8.43166 11.2127H6.93658V12.932H8.43166V11.2127ZM8.43166 8.63366H6.93658V10.353H8.43166V8.63366ZM13.6644 0.896606V4.33529H7.68412V0.896606H13.6644Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6885,
    height: 18.6885,
    fill: "white",
    transform: "translate(0.956299 0.377441)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServeys);
export default __webpack_public_path__ + "static/media/serveys.3bb722bb31abf2ff1e622c5c273918b0.svg";
export { ForwardRef as ReactComponent };